import { render, staticRenderFns } from "./StaticTextDemo.vue?vue&type=template&id=106cb45a"
import script from "./StaticTextDemo.vue?vue&type=script&lang=js"
export * from "./StaticTextDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports